module.exports = __webpack_public_path__ + "img/canjif.df479a48.png";